import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './components/Login';
import PrintPreview from './components/PrintPreview';
import CoverLetter from './components/CoverLetter';
import './App.css';
import { UserProvider } from './contexts/UserContext';
import InterviewQuestions from './components/InterviewQuestions';
import SettingsPage from './components/Settings';
import Footer from './components/Footer'
import AboutUs from './components/AboutUs';
import ResumeBuilderTest from './components/ResumeBuilderTest';
import HowToUse from './components/HowToUse';
import { Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import CoverLetterBuilder from './components/CoverLetterBuilder';
import CoverLetterPrintPreview from './components/CoverLetterPrintPreview';
import InterviewQuestion from './components/InterviewQuestion';

const App = () => {
  return (
    <UserProvider>
    <div className="appContainer">
      <Router>
        <Navbar />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/cover-letter" element={<CoverLetterBuilder />} />
            <Route path="/print-cover-letter" element={<CoverLetterPrintPreview />} />
            <Route path="/interview-questions" element={<InterviewQuestion />} />
            <Route path="/interview-question" element={<InterviewQuestion />} />
            <Route path="/resume-builder" element={<ResumeBuilderTest />} />
            <Route path="/login" element={<Login />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/how" element={<HowToUse />} />
            <Route path="/print" element={<PrintPreview />} />
            {/* Wildcard route to redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer /> {/* Add Footer here, after Routes */}
        </Router>
    </div>
    </UserProvider>
  );
};

export default App;
